// Browser file-save helpers shared by every synchronous export/print surface
// (bank metadata XLSX, gradebook XLSX, login-badge PDF).

/** Trigger a browser download for a Blob via a temporary anchor. */
export const triggerBlobDownload = (blob: Blob, filename: string) => {
  const url = window.URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  // Revoke after a tick so the click handler has time to consume the URL.
  window.setTimeout(() => window.URL.revokeObjectURL(url), 0);
};

/** Server-supplied download name, RFC 5987 form first; null when absent. */
export const filenameFromContentDisposition = (disposition?: string): string | null => {
  if (!disposition) return null;
  const matchUtf8 = /filename\*=UTF-8''([^;]+)/i.exec(disposition);
  if (matchUtf8?.[1]) {
    try {
      return decodeURIComponent(matchUtf8[1]).trim();
    } catch {
      // Malformed percent-escape — fall through to the plain filename.
    }
  }
  const matchPlain = /filename="?([^";]+)"?/i.exec(disposition);
  return matchPlain?.[1]?.trim() ?? null;
};
